import APIS from "./APIS"
import Cookies from "universal-cookie"

const isBrowser = typeof window !== `undefined`

export const setUser = (user) => {
  (window.localStorage.RisUpTheScanUser = JSON.stringify(user))
}

const getUser = () => {
  if (window.localStorage.RisUpTheScanUser) {
    let user = JSON.parse(window.localStorage.RisUpTheScanUser)
    return user ? user : {}
  }
  return {}
}

export const isLoggedIn = () => {
  if (!isBrowser) return false

  const user = getUser()
  if (user && user.id && user.email) {
    return user.id
  } else {
    return false
  }
}

export const logout = callback => {
  if (!isBrowser) return

  // 1) fermer la session cote serveur (c'est elle qui fait foi).
  //    Auparavant cet appel etait commente : la session restait ouverte.
  APIS.postLogout().finally(() => {
    // 2) menage local : cookie + localStorage
    const cookies = new Cookies()
    const cookieNames = Object.keys(cookies.getAll())
    const searchString = process.env.REACT_APP_COOKIES_SESSION || "pp.connect.sid"
    const host = document.location.hostname
    // domaines a tenter : sans domaine, le domaine exact, et le domaine parent
    // pour un nom de type sous.domaine.tld. Sur une adresse IP, seuls les deux
    // premiers ont un sens — l'ancien calcul produisait ".168.1.16", inexistant,
    // et le cookie survivait donc a la deconnexion.
    const estIP = /^[0-9.]+$/.test(host)
    const domaines = [undefined, host]
    if (!estIP) {
      const parts = host.split(".")
      if (parts.length > 2) { domaines.push("." + parts.slice(-2).join(".")) }
      domaines.push("." + host)
    }
    cookieNames.forEach((cook) => {
      if (cook.includes(searchString)) {
        domaines.forEach((d) => {
          try { cookies.remove(cook, d ? { path: '/', domain : d } : { path: '/' }) } catch (e) {}
        })
      }
    })
    setUser({})
    callback()
  })
}


export const getCurrentUser = () => isBrowser && getUser()
